import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-scroll'
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { layoutActions } from '../../store/layoutStore';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { popupActions } from '../../store/popupStore';
import { reportActions } from '../../store/reportStore'

import './entityIdentRow.scss';
import { searchActions } from '../../store/searchStore';
import TopStableBadge from "../../img/topStableCompanyGRBadge.svg";
import StableBadge from "../../img/stableCompanyGRBadge.svg";

class Badge extends React.Component {

    render() {
        const entityInfo = !isNullOrUndefined(this.props.entityInfos[this.props.entityId]) ? this.props.entityInfos[this.props.entityId].result : null;

        if (isNullOrUndefined(entityInfo))
            return <></>;

        const sectionName = this.props.isShortReport ? "ShortReportRatingData" : "RatingData";

        let badgeSource = entityInfo.topStableCompany ? TopStableBadge : StableBadge;
        if (entityInfo.topStableCompany) {
            return <div className='badge-row'>
                <Link to={sectionName} smooth={true} duration={100}><img src={badgeSource} className="badge-img"/></Link>
            </div>;
        }

        if (entityInfo.stableCompany) {
            return <div className='badge-row'>
                <Link to={sectionName} smooth={true} duration={100}>
                    <img src={badgeSource} className="badge-img"/></Link>
            </div>;
        }
        return <></>;
    }



}

export default withLocalize(connect(
    state => ({ ...state.entityIdentRow, ...state.report, ...state.layout, user: state.userContext, charts: state.charts }),
    dispatch => bindActionCreators({ ...entityIdentRowActions, ...layoutActions, ...lastSubjectActions, ...popupActions, ...searchActions, ...reportActions }, dispatch)
)(Badge));